// ===== POC Cuidados Paliativos (PNCP) - pedidos de apoio à equipe matricial =====
// Substitui o antigo mocks/matrixSupportStorage.js. As constantes e o formato
// dos pedidos são os mesmos de antes; as funções agora chamam a API.

import { apiGet, apiPost, query } from "./http";

export const MATRIX_TEAM = {
  name: "Equipe matricial de cuidados paliativos"
};

export const MODALITY_OPTIONS = [
  {
    _id: "teleconsultoria",
    name: "Teleconsultoria",
    description: "Entre as equipes, sem o paciente"
  },
  {
    _id: "teleinterconsulta",
    name: "Teleinterconsulta",
    description: "Com a participação do paciente"
  }
];

export const REASON_OPTIONS = [
  { _id: "sintomas", name: "Controle de sintomas" },
  { _id: "conferencia", name: "Conferência familiar" },
  { _id: "plano", name: "Definição do plano de cuidados" },
  { _id: "transicao", name: "Transição de cuidado (alta)" },
  { _id: "outro", name: "Outro" }
];

// Ciclo do pedido: a assistencial envia (Recebido), a matricial aceita
// (Em discussão) e responde com um parecer (Respondido).
export const REQUEST_STATUS = {
  received: "Recebido",
  discussing: "Em discussão",
  answered: "Respondido"
};

// Status numérico da API (0, 1, 2) → texto usado nas telas.
const STATUS_BY_CODE = [REQUEST_STATUS.received, REQUEST_STATUS.discussing, REQUEST_STATUS.answered];

// Classe CSS do selo de status, usada nas telas das duas equipes.
export function statusClass(status) {
  if (status === REQUEST_STATUS.discussing) return "is-discussing";
  if (status === REQUEST_STATUS.answered) return "is-answered";
  return "is-received";
}

export function toMatrixRequest(r) {
  return {
    id: r.Id,
    patientId: r.PatientId,
    patientName: r.PatientName,
    patientPhoto: r.PatientPhoto,
    patientGender: r.PatientGender,
    assistencialUnitId: r.AssistencialUnitId,
    assistencialUnitName: r.AssistencialUnitName,
    requesterId: r.Requester ? r.Requester.Id : null,
    requesterName: r.Requester ? r.Requester.Name : "",
    modality: r.Modality,
    reason: r.Reason,
    question: r.Question,
    status: STATUS_BY_CODE[r.Status] || REQUEST_STATUS.received,
    createdAt: r.CreatedAt,
    acceptedAt: r.AcceptedAt,
    acceptedBy: r.AcceptedBy ? r.AcceptedBy.Name : "",
    response: r.Response && r.Response.Text
      ? {
        text: r.Response.Text,
        author: r.Response.RespondedBy ? r.Response.RespondedBy.Name : "",
        createdAt: r.Response.RespondedAt
      }
      : null,
    reassessInDays: r.ReassessInDays,
    reassessDueDate: r.ReassessDueDate,
    reassessActionId: r.ReassessActionId,
    messages: (r.Messages || []).map((m) => ({
      id: m.Id,
      team: m.Team,
      authorName: m.Professional ? m.Professional.Name : "",
      text: m.Text,
      createdAt: m.CreatedAt
    }))
  };
}

/** Pedidos visíveis para o profissional (matricial: todos da instituição; assistencial: os das suas unidades). */
export async function listMatrixRequests(status) {
  const code = status == null ? null : STATUS_BY_CODE.indexOf(status);
  const data = await apiGet(`/matrix-requests${query({ status: code >= 0 ? code : null })}`);
  return (data || []).map(toMatrixRequest);
}

export async function listPatientMatrixRequests(patientId) {
  const data = await apiGet(`/matrix-requests/patient/${patientId}`);
  return (data || []).map(toMatrixRequest);
}

export async function addMatrixRequest(patientId, { modality, reason, question }) {
  return toMatrixRequest(await apiPost(`/matrix-requests/patient/${patientId}`, {
    Modality: modality,
    Reason: reason,
    Question: question
  }));
}

export async function acceptMatrixRequest(id) {
  return toMatrixRequest(await apiPost(`/matrix-requests/${id}/accept`));
}

// Discussão do caso (Tela 3).
export async function addMatrixMessage(id, text) {
  return toMatrixRequest(await apiPost(`/matrix-requests/${id}/messages`, { Text: text }));
}

// Parecer. Com reavaliação, a API cria a ação para quem pediu o apoio.
export async function respondMatrixRequest(id, text, reassessInDays) {
  return toMatrixRequest(await apiPost(`/matrix-requests/${id}/response`, {
    Text: text,
    ReassessInDays: reassessInDays || null
  }));
}
